import React, {useEffect, useMemo, useState, useCallback, useContext} from 'react';
import Aux from '../../../../hoc/Auxiliary';
import {useTranslation} from "react-i18next";
import formatDate from "../../../Utils/Date/formatDate";
import DateFormated from "../../../Utils/Date/Date";
import TableContainer from "./Table/TableContainer";
import DateFilters, {DEFAULT_DATE, TODAY} from "../Tables/DateFilters";
import Spinner from "../../../UI/Spinner";
import DisplaySwitcher from "../../../UI/Toolbar/DisplaySwitcher";
import CardGeneric from "../../../Cards/CardGeneric";
import SearchForm from "../../../UI/SearchForm/SearchForm";
import Sorter from "../../../UI/Toolbar/Sorter";
import axios from "../../../../axios-defaults";
import Pagination from "../../../UI/Pagination";
import Currency from "../../../Utils/Number/Currency";
import ManageCard from "./Modals/ManageCard";

import UserContext from '../../../../context/user-context';
import {userHaveSpecificPermission} from "../../../Utils/UserHelper";
import ModalMxo from "../../../UI/Modal";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {logPlugin} from "@babel/preset-env/lib/debug";

const summary = (props) => {
    const { user } = useContext(UserContext);
    const { startDate, endDate, pageNumber, pageSize, currentPeriod, subAccountCode, subAccountType, reloadCardSummary} = props;
    const {t, i18n} = useTranslation();
    const [originalData, setOriginalData] = useState([]);
    const [items, setItems] = useState([]);
    const [sortField, setSortField] = useState('lastTransactionDate');
    const [sortDirection, setSortDirection] = useState('DESC');
    const [sortTableField, setSortTableField] = useState('lastTransactionDate');
    const [sortTableDirection, setSortTableDirection] = useState('DESC');
    const [loading, setLoading] = useState(0);
    const [pagination, setPagination] = useState({currentPage: 1, itemsPerPage: 6, totalPages: null});
	const [reloadCardSummaryState, setReloadCardSummaryState] = useState(reloadCardSummary);

    //Modal Alert Setting
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState(null);

    const showCardlockMessage = () => {
        if (subAccountType !== 'K') return false;

        let expiration = new Date(CARDLOCK_MESSAGE_EXPIRE);
        let today = new Date();
        if (today > expiration) return false;

        return true;
    }

    const getCardsSummary = async () => {
        let params = '';
        if (pageNumber && pageSize) {
            params = `subAccountCode=${subAccountCode}`
        } else {
            if (startDate === null || endDate === null) {
                return;
            } else {
                const currentStartDate = (startDate)?startDate:DEFAULT_DATE;
                const currentEndDate = (endDate)?endDate:formatDate(TODAY);
                params = `subAccountCode=${subAccountCode}&currentPeriod=${currentPeriod}&startDate=${currentStartDate}&endDate=${currentEndDate}`;
            }
        }

        await axios.get(`/subAccounts/CardTransactionSummary?${params}`)
            .then(response => {
                if(response.data.succeeded)  {
                    setOriginalData(response.data.data);
                    setItems(response.data.data);
                }
            }).catch(error => {
                console.log('[Account.js] : Cards Summary ajax error in getCardsSummary()',error.message);
        });
    }

    useEffect(async () => {
        setLoading(true)
        await getCardsSummary()
        setLoading(false)
    }, [startDate, endDate, pageNumber, pageSize, reloadCardSummary, reloadCardSummaryState]);


    let sorter = null;
    const setSorterRef = element => sorter = element;

    const storeSortedItems = (items) => {
        if (items && items.length) {
            setItems(items);
        }
    }
    const setSorterCallback = (columnId, direction) => {
        setSortTableField(columnId)
        setSortTableDirection(direction)
    }

    const setTransactionTab = (current_name,current_card_last) => {
        props.refreshTabs('transactions', {owner: current_name + ' ('+ current_card_last + ')'});
    }

    const objectFloatSort = useMemo(
        () => (rowA, rowB, columnId) => {
            const a = parseFloat(rowA.values[columnId].value.toFixed(2));
            const b = parseFloat(rowB.values[columnId].value.toFixed(2));
            return a > b ? 1 : -1;
        },
        []
    );

    const objectCardNumberSort = useMemo(
        () => (rowA, rowB, columnId) => {
            const valueA = rowA.values[columnId];
            const valueB = rowB.values[columnId];
            const a = valueA.slice(valueA.length - 4);
            const b = valueB.slice(valueB.length - 4);
            return a > b ? 1 : -1;
        },
        []
    );

    const columns = useMemo(
        () => [
            {
                Header: t('account.tabs.summary.table.card_number_header'),
                accessor: 'cardNumber',
                sortType: objectCardNumberSort,
                Cell: (props) => {
                    if (props.value && props.row.original.cardStatus.code !== '099') {
                        return <strong>XXXX&nbsp;XXXX&nbsp;XXXX&nbsp;{props.value.slice(props.value.length - 4)}</strong>;
                    } else {
                        return '';
                    }
                },
            },
            {
                Header: t('account.tabs.summary.table.cardholder_header'),
                accessor: 'cardHolder',
                Cell: (props) => {
                    if (props.value) return <strong>{props.value}</strong>;
                    else return '';
                },
            },
            {
                Header: t('account.tabs.summary.table.consumption_header'),
                accessor: 'quantity',
                sortType: objectFloatSort,
                Cell: (props) => {
                    if (props.value.value) {
                        return <strong
                            className="amount-qty">{props.value.value.toFixed(2) + ' ' + props.value.unit}</strong>;
                    } else {
                        return '';
                    }
                },
            },
            {
                Header: t('account.tabs.summary.table.amount_header'),
                accessor: 'amount',
                sortType: objectFloatSort,
                Cell: (props) => {
					return <strong className="amount-price">
                        <Currency value={props.value ? props.value.value.toFixed(2) : 0}  /><br/>
                        <a href="" className={`link--gray link--underline link--fs-14 ${props.row.original.cardStatus.code === '099' ? 'invisible': ''}`}
                           onClick={
                               (e) => {
                                   e.preventDefault();
                                   let current_name = (e.target.parentNode.parentNode.parentNode.cells[1].innerHTML).replace(/<[^>]+>/g, '');
                                   let current_card = ((e.target.parentNode.parentNode.parentNode.cells[0].innerHTML).replace(/<[^>]+>/g, ''));
                                   let current_card_last = current_card.slice(current_card.length - 4);
                                   setTransactionTab(current_name,current_card_last);
                               }
                           }
                           target="_self">
                            {t("account.summary.statement.transactions_btn")}
                        </a>
                    </strong>;
                },
            },
            {
                // id: 'date',
                Header: t('account.tabs.summary.table.last_transaction_header'),
                accessor: 'lastTransactionDate',
                sort: 'desc',
                Cell: (props) => {
                    if (props.value) return <DateFormated date={props.value} withTime={true}/>;
                    else return '';
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1)
                        return 1;
                    else if (a1 > b1)
                        return -1;
                    else
                        return 0;
                }
            },
            {
                Header: t('account.tabs.summary.table.status_header'),
                id: 'cardStatus',
                accessor: ((i18n.language === "fr") ? 'cardStatus.descriptionFr' : 'cardStatus.descriptionEn'),
                Cell: (props) => {
                    if (props.value) return <strong>{props.value}</strong>;
                    else return '';
                },
            },
            {
                Header: () => null,
                id: 'file', // 'id' is required
                accessor: '',
                Cell: (props) => {
                    return (''
                        /* <a href={props.value} target="_blank" className="link link--red link--upper link--accent link--fs-14">
                             <strong>
                                 Gérer ce chauffeur&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                             </strong>
                         </a>*/
                    );
                }
            },
            {
                Header: () => userHaveSpecificPermission(user, 'financial_data') && userHaveSpecificPermission(user, 'manage_cards') && t('account.tabs.summary.table.manage_header'),
                id: 'actions', // 'id' is required
                accessor: '',
                Cell: (props) => {
                    let currentCard = props.row.original;
                    if(userHaveSpecificPermission(user, 'financial_data') && userHaveSpecificPermission(user, 'manage_cards')) {
                        return (
                            <div className="a-center manage-card-icon">
                                {currentCard.isSelfServiceAllowed ?
                                    <a href={props.value}
                                       target="_blank"
                                       className="link link--red link--upper link--accent link--fs-14"
                                       title={ t('account.cards.management.action_title') }
                                       onClick={e => {
                                           e.preventDefault();
                                           editCardModalHandler(currentCard);
                                       }}>
                                        <span className="visually-hidden">{ t('account.cards.management.action_title') }</span>
                                        <i className="far fa-edit"></i>
                                    </a> :

                                    <OverlayTrigger placement="top"
                                        overlay={<Tooltip id="tooltip-top">
                                            {i18n.language === "fr" ? currentCard.selfServiceNotAllowedReason.descriptionFr : currentCard.selfServiceNotAllowedReason.descriptionEn}
                                        </Tooltip>}>
                                        <a href={props.value}
                                           className="link link--red link--upper link--accent link--fs-14 link--disabled"
                                           title={ t('account.cards.management.action_title') }>
                                            <i className="far fa-edit"></i>
                                        </a>
                                    </OverlayTrigger>
                            }
                            </div>
                        )
                    } else {
                        return null;
                    }
                }
            },
        ],
        [t, i18n, items]
    );

    const handleSort = useCallback(sortBy => {
        if (sortBy.length > 0) {
            setSortField(sortBy[0].id);
            setSortDirection(sortBy[0].desc?'DESC':'ASC')
        }
    }, [])

    const setSortByCallback = useMemo(() =>
        [{desc:sortTableDirection==='DESC', id:sortTableField}]
    , [sortTableDirection, sortTableField])

    const onPageChanged = data => {
        const { currentPage, totalPages } = data;
        setPagination({
                ...pagination,
                currentPage: currentPage,
                totalPages: totalPages,
        });
    }

    const onSearchDataUpdate = (searchData) => {
        if (Array.isArray(searchData)) {
            return setItems(searchData);
        } else {
            return null;
        }
    }

    let dataHtml = '';
    if (loading) {
        dataHtml = <Spinner/>
    } else {
        if (props.currentDisplayMode === 'list') {
            dataHtml = (
                <TableContainer columns={columns}
                                data={items}
                                onSort={handleSort}
                                setSortByCallback={setSortByCallback}
                                initialStateField={sortField}
                                initialStateDirection={sortDirection}
                />
            )
        } else if (props.currentDisplayMode === 'card') {
            const pageLimit = pagination.itemsPerPage;
            const currentPage = pagination.currentPage;
            const offset = (currentPage - 1) * pageLimit;
            const itemsPaged = items.slice(offset, offset + pageLimit);
            const totalCurrentItems = (items) ? items.length : 0;
            if (!totalCurrentItems) {
                dataHtml = (t('account.summary.noitems'))
            }  else {
                dataHtml = (
                    <Aux>
                        <div className="row">
                        {itemsPaged.map((item, index) => {
                            const localeAccessor = (i18n.language === "fr") ? 'descriptionFr' : 'descriptionEn';
                            return (
                                <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
                                    <CardGeneric title={item.cardHolder}>
										{item.cardStatus.code !== '099' &&
											<p>
												<strong>XXXX&nbsp;XXXX&nbsp;XXXX&nbsp;{item.cardNumber.slice(item.cardNumber.length - 4)}</strong>
											</p>
										}
                                        <div className="row row--addline"></div>
                                        <div className="row row--addline mb-2 mb-sm-3 mt-2 mt-sm-3">
                                            {(() => {
                                                if (item.cardStatus[localeAccessor]) {
                                                    return (
                                                        <div className="col-6 col-sm-6">
                                                            <p>
                                                                {t('account.tabs.summary.table.status_header')}<br/>
                                                                <strong>{item.cardStatus[localeAccessor]}</strong>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            {(() => {
                                                if (item.lastTransactionDate) {
                                                    return (
                                                        <div className="col-6 col-sm-6 d-flex justify-content-start justify-content-sm-end text-sm-right">
                                                            <p>
                                                                {t('account.tabs.summary.table.last_transaction_header')}<br/>
                                                                <strong><DateFormated date={item.lastTransactionDate}
                                                                                      withTime={true}/></strong>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                        </div>

                                        <div className="row mt-2 mt-sm-3">
                                            {(() => {
                                                if (item.quantity.value) {
                                                    return (
                                                        <div className="col-6 col-sm-6">
                                                            <p>
                                                                {t('account.tabs.summary.table.consumption_header')}<br/>
                                                                <strong
                                                                    className="amount-qty">{item.quantity.value.toFixed(2) + ' ' + item.quantity.unit}</strong>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            {(() => {
                                                if (userHaveSpecificPermission(user, 'financial_data') && item.amount.value) {
                                                    return (
                                                        <div className="col-6 col-sm-6 d-flex justify-content-start justify-content-sm-end">
                                                            <p>
                                                                {t('account.tabs.summary.table.amount_header')}<br/>
                                                                <strong className="amount-price">
                                                                    <Currency value={item.amount.value.toFixed(2)}  />
                                                                </strong>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                        {(() => {
                                            if (userHaveSpecificPermission(user, 'financial_data')) {
                                                return (
                                                    <div className="d-flex justify-content-start justify-content-sm-end">
														<a href="" className={`link--gray link--underline link--fs-14 ${item.cardStatus.code === '099' ? 'invisible': ''}`}
                                                           onClick={(e) => {
                                                               e.preventDefault();
                                                               props.refreshTabs('transactions', {owner: item.cardHolder + ' ('+ item.cardNumber.slice(item.cardNumber.length - 4) + ')'});
                                                           }}
                                                           target="_self">
                                                            <strong>{t("account.summary.statement.transactions_btn")}</strong>
                                                        </a>
                                                        &nbsp;&nbsp;
                                                        {userHaveSpecificPermission(user, 'manage_cards')&&
                                                            <div className="a-center manage-card-icon">

                                                                {item.isSelfServiceAllowed ?
                                                                    <a href={props.value}
                                                                       target="_blank"
                                                                       className="link link--red link--upper link--accent link--fs-14"
                                                                       title={ t('account.cards.management.action_title') }
                                                                       onClick={e => {
                                                                           e.preventDefault();
                                                                           editCardModalHandler(item);
                                                                       }}>
                                                                        <span className="visually-hidden">{ t('account.cards.management.action_title') }</span>
                                                                        <i className="far fa-edit"></i>
                                                                    </a> :

                                                                    <OverlayTrigger placement="top"
                                                                        overlay={<Tooltip id="tooltip-top">
                                                                            {i18n.language === "fr" ? item.selfServiceNotAllowedReason.descriptionFr : item.selfServiceNotAllowedReason.descriptionEn}
                                                                        </Tooltip>}>
                                                                        <a href={props.value}
                                                                           className="link link--red link--upper link--accent link--fs-14 link--disabled"
                                                                           title={ t('account.cards.management.action_title') }>
                                                                            <i className="far fa-edit"></i>
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </CardGeneric>
                                </div>
                            );
                        })}
                        </div>
                        <Pagination totalRecords={totalCurrentItems} pageLimit={pagination.itemsPerPage} pageNeighbours={1} onPageChanged={onPageChanged} />
                    </Aux>
                );
            }
        }
    }

    let sorterOptions = [
        {
            label: t('account.tabs.summary.table.choose'),
            id: 'none',
            value: '',
        },{
            label: t('account.tabs.summary.table.card_number_header'),
            id: 'cardNumber',
            value: 'cardNumber',
            type: 'card'
        },{
            label: t('account.tabs.summary.table.cardholder_header'),
            id: 'cardHolder',
            value: 'cardHolder',
            type: 'string'
        },{
            label: t('account.tabs.summary.table.consumption_header'),
            id: 'quantity',
            value: 'quantity.value',
            type: 'float'
        }];

    if (userHaveSpecificPermission(user, 'financial_data')){
        sorterOptions.push({
            label: t('account.tabs.summary.table.amount_header'),
            id: 'amount',
            value: 'amount.value',
            type: 'float'
        });
    }

    sorterOptions.push(
        {
            label: t('account.tabs.summary.table.last_transaction_header'),
            id: 'lastTransactionDate',
            value: 'lastTransactionDate',
            type: 'date'
        }, {
            label: t('account.tabs.summary.table.status_header'),
            id: 'cardStatus',
            value: ((i18n.language === "fr") ? 'cardStatus.descriptionFr' : 'cardStatus.descriptionEn'),
            type: 'string'
        });

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const editCardModalHandler = async (currentCard) => {
        setModalTitle(t('account.cards.management.modal_title'));
        setModalContent(<ManageCard cardData={currentCard} closeModal={handleCloseModal} changeModalTitle={setModalTitle} subAccountType={subAccountType} reloadCardSummary={() => setReloadCardSummaryState(reloadCardSummaryState => reloadCardSummaryState + 1)}/>);
        handleShowModal();
    }

    return (
        <Aux>
            <h2 className="headline headline--section headline--uppercase">
                {t('account.tabs.summary.title')}
            </h2>

            {showCardlockMessage() &&
            <div className={"mb-2"}>
                <div className="message message--warning" style={{minHeight:0}}>
                    <div className="message__icon"><i className="far fa-info-circle" aria-hidden="true"></i></div>
                    <div className="message__content d-block">
                        <p className="mb-0" style={{fontSize:'16px'}}>{t('account.tabs.summary.cardlock_alert')}&nbsp;
                            <a href={'/pdf/file.pdf'} target={'_blank'} style={{whiteSpace:'nowrap'}}>{t('account.tabs.summary.learnmore')}</a>
                        </p>
                    </div>
                </div>
            </div> }
            <SearchForm data={originalData} currentData={items} updateData={onSearchDataUpdate} placeholder={t('account.tabs.summary.search_placeholder')} />
            <br/>
            <div className="flex top-actions flex-wrap">
                <DateFilters
                    startDate={props.startDate}
                    endDate={props.endDate}
                    setStartDate={props.setStartDate}
                    setEndDate={props.setEndDate}
                    changeDateFilterType={props.changeDateFilterType}
                    dateFilterType={props.dateFilterType}
                    enableCurrentPeriod={props.enableCurrentPeriod}
                    displayCurrentPeriod={props.displayCurrentPeriod}
                    component="summary"
                    labelFilterAll={t("docs.invoices.table.filter.all.summary")}
                />
                <div className="flex justify-content-end summary-actions mt-0 mt-sm-2 flex--align-self-start">
                    <Sorter
                        sortOptions={sorterOptions}
                        items={items}
                        getSortedItems={storeSortedItems}
                        setSortByCallback={setSorterCallback}
                        sortDirection={sortDirection}
                        sortField={sortField}
                        currentDisplayMode={props.currentDisplayMode}
                    />
                </div>
                <div className="flex justify-content-end mt-0 mt-sm-2 flex--align-self-start flex-grow-1 mb-4">
                    <DisplaySwitcher
                        currentDisplayMode={props.currentDisplayMode}
                        setDisplayMode={props.setDisplayMode}/>
                </div>
            </div>
            {dataHtml}
            <ModalMxo title={modalTitle}
                      show={showModal}
                      hideFooter={true}
                      footerActions={null}
                      backDrop='static'
                      onHide={handleCloseModal}
                      onShow={handleShowModal}
            >
                {modalContent}
            </ModalMxo>
        </Aux>
    );
}

export default summary;
